<button type="button"
        class="secondary-btn cp-trigger"
        (click)="toggleOpen($event)"
        [attr.aria-expanded]="open">
  <i class="bi bi-layout-three-columns"></i>
  <span>{{ label }}</span>
  <span class="cp-count" *ngIf="columns.length">{{ visible.size }}/{{ columns.length }}</span>
</button>

<div class="cp-backdrop" *ngIf="open" (click)="close()"></div>

<aside class="cp-drawer" [class.cp-drawer-open]="open" role="dialog" aria-label="Choose columns">
  <header class="cp-drawer-head">
    <div>
      <span class="cp-drawer-title">Visible Columns</span>
      <small class="cp-drawer-meta">{{ visible.size }} of {{ columns.length }} selected</small>
    </div>
    <button type="button" class="cp-drawer-close" aria-label="Close" (click)="close()">
      <i class="bi bi-x-lg"></i>
    </button>
  </header>

  <div class="cp-drawer-search">
    <i class="bi bi-search"></i>
    <input type="text"
           placeholder="Search columns…"
           [value]="search"
           (input)="onSearchChange($any($event.target).value)" />
    <button *ngIf="search" type="button" class="cp-search-clear" aria-label="Clear search" (click)="onSearchChange('')">
      <i class="bi bi-x"></i>
    </button>
  </div>

  <div class="cp-drawer-actions">
    <button type="button" class="btn-link" (click)="selectAll()">Select All</button>
    <button type="button" class="btn-link" (click)="clearAll()">Clear</button>
    <button type="button" class="btn-link" (click)="resetDefaults()">Default</button>
  </div>

  <div class="cp-drawer-list">
    <label *ngFor="let c of filteredColumns" class="cp-item" [class.cp-item-disabled]="c.pinned">
      <input type="checkbox"
             [checked]="isChecked(c)"
             [disabled]="c.pinned"
             (change)="toggle(c)" />
      <span class="cp-item-label">{{ c.label }}</span>
      <i *ngIf="c.pinned" class="bi bi-pin-angle-fill cp-pinned" title="Always visible"></i>
    </label>
    <p *ngIf="!filteredColumns.length" class="cp-empty">No columns match "{{ search }}".</p>
  </div>

  <footer class="cp-drawer-foot">
    <button type="button" class="primary-button" (click)="close()">Done</button>
  </footer>
</aside>
